(function () {
    'use strict';
    angular.module('app').directive('selectioncommanddeletedoc', selectioncommand_deletedoc);
    function selectioncommand_deletedoc() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                deleteDocDialogShown: '=?'
            },
            controller: 'delete',
            templateUrl: 'app/selectioncommand/selectioncommand_deletedoc.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();